import styled from 'styled-components';

import { Popup } from 'components/uikit/Popup/Popup';
import { ErrorCrossLImg, OkLImg } from 'assets/images';

export const StyledPopup = styled(Popup)`
  width: 620px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 16px;
`;

export const Title = styled.h2`
  margin-bottom: 0px;

  font: var(--font-heading-large-20_2);
`;

export const Description = styled.p`
  margin: 8px 0 0 0;
  color: var(--color-grey-11_60);

  font: var(--font-regular-15);
`;

export const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
`;

export const StyledOkImg = styled(OkLImg)``;

export const StyledErrorCrossImg = styled(ErrorCrossLImg)``;
